export default __webpack_public_path__ + "static/fluo-og-image-e7cd06e19306126d59c9ee12f21be044.png";